// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_GetFilteredCustomersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /mensagens_programadas_lote/get_filtered_customers
 *
 * Returns a list of customers filtered by franchise IDs, date range, and maximum count.
 */
import type { MensagensProgramadasLote_GetFilteredCustomersRow } from './MensagensProgramadasLote_GetFilteredCustomersRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadasLote_GetFilteredCustomersResponseDados {
customers: MensagensProgramadasLote_GetFilteredCustomersRow[]
total: number
}

export type MensagensProgramadasLote_GetFilteredCustomersResponse = ApiResponse<MensagensProgramadasLote_GetFilteredCustomersResponseDados>;

registerResponseContract('MensagensProgramadasLote_GetFilteredCustomersResponse', {
  customers: {
    type: 'array',
    required: true,
    items: {
      cliente_id:                              { type: 'number',  required: true },
      cliente_nome:                            { type: 'string',  required: true },
      cliente_franquia_id:                     { type: 'number',  required: true },
      cliente_telefone:                        { type: 'string',  required: false },
      cliente_ddd:                             { type: 'string',  required: false },
      cliente_ddi:                             { type: 'string',  required: false },
      cliente_data_ultimo_compromisso:         { type: 'string',  required: false },
      cliente_data_ultimo_contato_fidelizacao: { type: 'string',  required: false },
      cliente_bairro:                          { type: 'string',  required: false },
      cliente_location_id:                     { type: 'number',  required: false },
      cliente_location_type:                   { type: 'string',  required: false },
      franquia:                                { type: 'string',  required: false },
      localidade:                              { type: 'string',  required: false },
    },
  },
  total:     { type: 'number',  required: true },
})
